import {Routes} from '@angular/router';

import {SettingsComponent} from './components/settings/settings.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';


export const CONFIG_ROUTES: Routes = [
    {path: 'settings', component: SettingsComponent},
    {path: 'dashboard', component: DashboardComponent},
];



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/config/config.routes.ts